export default __webpack_public_path__ + "static/media/heightMeasure.41860fc1.gif";